import { Button } from 'components/Elements';
import { Form, InputField, PhoneInputField } from 'components/Form';
import { useAuth } from 'lib/auth';
import PropTypes from 'prop-types';
import * as z from 'zod';
import { requestOTP } from '../api/requestOTP';
import storage from 'utils/storage';
import { useState } from 'react';

const schema = z.object({
  phoneNumber: z.string().min(1, 'Required'),
});

export const PhoneNumberLoginForm = ({ onSuccess }) => {
  const [loading, setLoading] = useState(false);

  return (
    <div>
      <Form
        onSubmit={async (values) => {
          setLoading(true);
          const phone = `256${values.phoneNumber}`;
          storage.setUserPhoneNumber(phone);
          await requestOTP({
            phoneNumber: phone,
          }).catch(() => {
            setLoading(false);
          });
          onSuccess();
        }}
        schema={schema}
      >
        {({ register, formState }) => (
          <>
            <PhoneInputField
              type="text"
              label="Phone Number"
              error={formState.errors['phoneNumber']}
              registration={register('phoneNumber')}
            />
            <div>
              <Button isLoading={loading} type="submit" className="w-full">
                Continue
              </Button>
            </div>
          </>
        )}
      </Form>
    </div>
  );
};

PhoneNumberLoginForm.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};
